import { render, staticRenderFns } from "./emitLipscolorchanger.vue?vue&type=template&id=5853ef0b&scoped=true"
import script from "./emitLipscolorchanger.vue?vue&type=script&lang=js"
export * from "./emitLipscolorchanger.vue?vue&type=script&lang=js"
import style0 from "./emitLipscolorchanger.vue?vue&type=style&index=0&id=5853ef0b&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5853ef0b",
  null
  
)

export default component.exports